<template>
  <div>
    <canvas id="watermarkCanvas"></canvas>
  </div>
</template>
<script>
export default {
  mounted() {
    this.initWater()
  },
  methods: {
    initWater() {
      let user = this.USER()
      createWatermark(user.realname + user.mobile, 0.1, 1);

      function createWatermark(text, opacity, density) {
        const canvas = document.getElementById('watermarkCanvas');
        const ctx = canvas.getContext('2d');
        // 设备像素比
        // const scale = window.devicePixelRatio || 1;

        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        // 缩放 canvas 上下文
        // ctx.scale(scale, scale);

        ctx.clearRect(0, 0, canvas.width, canvas.height); // 清空画布
        ctx.globalAlpha = opacity; // 设置透明度
        ctx.fillStyle = 'black'; // 设置水印颜色为红色
        ctx.font = '14px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const textWidth = 200; // 水印文本宽度
        const textHeight = 50; // 水印文本高度

        const cols = Math.ceil(canvas.width / textWidth) * density;
        const rows = Math.ceil(canvas.height / textHeight) * density;

        for (let i = 0; i < cols; i++) {
          for (let j = 0; j < rows; j++) {
            ctx.save();
            ctx.translate(i * textWidth + textWidth / 2, j * textHeight + textHeight / 2);
            ctx.rotate(340 * Math.PI / 180); // 旋转
            ctx.fillText(text, 0, 0);
            ctx.restore();
          }
        }
      }


      function deleteContent() {
        const article = document.getElementById("index")
        if (article) {
          article.parentNode.removeChild(article); // 删除 article 标签
        }
      }

      // 监控 Canvas 元素的变化
      const observer = new MutationObserver(() => {
        const canvas = document.getElementById('watermarkCanvas');
        if (!canvas) {
          deleteContent(); // 如果 Canvas 被删除，删除内容
          
          window.location.replace(window.location.origin);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      window.addEventListener('resize', () => {
        createWatermark(user.realname + user.mobile, 0.1, 1);
      }); // 窗口调整时重新生成水印

    }
  }
}
</script>
<style  scoped>
canvas {
  position: fixed;
  width: 100%; /* 让 canvas 占满全屏 */
  height: 100%; /* 让 canvas 占满全屏 */
  top: 0;
  left: 0;
  pointer-events: none; /* 不干扰用户操作 */
  z-index: 9999;
}
</style>


// WEBPACK FOOTER //
// src/components/assembly/waterBox.vue